<template>
  <b-performance-table
    :data="rows"
    :custom-headers="headers"
    :loading="loading"
    :show-diff="dates.compareWith"
    :data-grouped-by="groupBy"
  />
  <!-- To rollback PS-733 changes
  <b-performance-table
    :data="rows"
    :custom-headers="headers"
    :loading="loading"
    :show-diff="dates.compareWith"
    :data-grouped-by="groupBy"
    :show-preview="true"
  />
  end of PS-733 changes-->
</template>

<script>
import { get } from 'vuex-pathify';
import { checkUserHasAiAssistant } from '@/util/utility-functions';
import EventBus from '@/adready-vue/helpers/global/event-bus';
import fetchWindowTypeDataMixin from '@/components/mixins/fetch-window-type-data-mixin';
import performanceDataMixin from '~/components/mixins/performance-data-mixin';

export default {
  name: 'DashDetailCreativesPerformanceList',
  components: {
    BPerformanceTable: () =>
      import(
        /* webpackChunkName: "b-performance-table" */ '~/components/elements/b-performance-table.vue'
      ),
  },

  mixins: [performanceDataMixin, fetchWindowTypeDataMixin],

  data() {
    return {
      loading: false,
      groupBy: 'creative',
      userHasAiAssistant: false,
    };
  },
  created() {
    EventBus.$on('is-chatbot-clicked', this.handleIsChatbotClicked);
  },
  beforeDestroy() {
    EventBus.$off('is-chatbot-clicked', this.handleIsChatbotClicked);
  },
  computed: {
    headers() {
      return [{ name: 'Name', sortKey: 'name' }, this.getCommonHeader()];
    },
    performance: get('dashboard/performance@creatives'),
    rows() {
      if (!this.performance) {
        return [];
      }
      const rows = this.performance.map((item) => {
        const rowItem = this.transformToRowItem(item);
        rowItem.name = item.name;
        return rowItem;
      });
      /** To rollback PS-733 changes
      const rows = this.performance.map((item) => {
        const rowItem = this.transformToRowItem(item);
        rowItem.name = item.name;
        rowItem.previewUrl = `https://creative-preview-an.com/cached/creative/${item.id}`;
        rowItem.nameColumnStyle = 'preview';
        rowItem.id = item.id;
        return rowItem;
      });
      end of PS-733 changes */
      return this.sortRows(rows);
    },
    currentUser: get('common/currentUser'),
  },
  async mounted() {
    try {
      if (!EventBus.isChatbotClicked) {
        await this.loadPerformanceCreativeData(this.payload);
      }
      this.userHasAiAssistant = checkUserHasAiAssistant(this.currentUser);
      if (this.userHasAiAssistant && EventBus.performanceAPILoadedOnAIEnabled === false) {
        this.loadAllPerformanceData(this.payload, 'creative');
      }
    } catch (err) {
      console.error('error mounting DashDetailCreativesPerformanceList ->', err);
      if (window.$sentry) {
        if (err._reported !== true) {
          window.$sentry.captureException(err);
          err._reported = true;
        }
      }
    }
  },
  methods: {
    async loadPerformanceData(payload) {
      await this.loadPerformanceCreativeData(payload);
      if (this.userHasAiAssistant) {
        this.loadAllPerformanceData(payload, 'creative');
      }
    },
    async handleIsChatbotClicked() {
      if (EventBus.performanceAPILoadedOnAIEnabled === false) {
        this.loadAllPerformanceData(this.payload, 'creative');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-bg.zero {
  margin-top: 0 !important;
  margin-left: -10px !important;
}
</style>
